import { useState } from 'react'

import { Icon } from '@joor/design-system'
import AliceCarousel from 'react-alice-carousel'
import 'react-alice-carousel/lib/alice-carousel.css'
import styled, { css } from 'styled-components'

import { getSizedImageUrl } from 'utils/images'

const StyledCarouselContainer = styled.div`
  width: 100%;
  max-width: 100%;
  margin: 0;
  position: relative;
  .alice-carousel,
  .alice-carousel__wrapper {
    width: 100% !important;
  }
  .alice-carousel__wrapper {
    height: 458px !important;
    overflow: hidden;
  }
  .alice-carousel__stage {
    width: 100% !important;
  }
  .alice-carousel__dots {
    margin: 15px 0 0 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  .alice-carousel__dots-item {
    background-color: var(--color-primary-200) !important;
    margin: 0 4px !important;
    border-radius: 50% !important;
  }
  .__active {
    background-color: var(--color-primary-400) !important;
  }
  .alice-carousel__stage-item {
    background: white !important;
    text-align: center;
  }
`
const StyledImage = styled.img`
  width: 100%;
  height: 458px;
  object-fit: cover;
  object-position: center;
  border-radius: 4px;
`
const baseButtonStyles = css`
  position: absolute;
  top: calc(50% - 20px);
  border-radius: 40px;
  border: 1px solid var(--color-primary-100);
  background: var(--color-neutral-100);
  opacity: 40%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  :hover {
    opacity: 100%;
  }
`
const StyledLeftButton = styled.div`
  ${baseButtonStyles}
  left: 16px;
`
const StyledRightButton = styled.div`
  ${baseButtonStyles}
  right: calc(0% + 16px);
`
const StyledDot = styled.div`
  height: 8px;
  width: 8px;
  cursor: pointer;
`

const getItems = (imageUrls: string[]) =>
  imageUrls.map((imageUrl: string) => (
    <StyledImage
      src={getSizedImageUrl(imageUrl, '1200x800')}
      alt="carousel-image"
    />
  ))

type CarouselProps = {
  imageUrls: string[]
  testId?: string
}

const Carousel = ({ imageUrls, testId }: CarouselProps) => {
  const [autoPlay, setAutoPlay] = useState<boolean>(true)

  const items = getItems(imageUrls)
  const extraProps = {
    ...(imageUrls.length > 1 && {
      autoPlay,
      animationDuration: 400,
      autoPlayInterval: 5000,
      infinite: true,
      renderPrevButton: () => {
        return (
          <StyledLeftButton onClick={() => setAutoPlay(false)}>
            <Icon iconName="chevron-left" />
          </StyledLeftButton>
        )
      },
      renderNextButton: () => {
        return (
          <StyledRightButton onClick={() => setAutoPlay(false)}>
            <Icon iconName="chevron-right" />
          </StyledRightButton>
        )
      },
      renderDotsItem: () => {
        return <StyledDot onClick={() => setAutoPlay(false)} />
      },
    }),
    ...(imageUrls.length <= 1 && {
      disableButtonsControls: true,
      disableDotsControls: true,
    }),
  }

  return (
    <StyledCarouselContainer data-testid={testId ?? ''}>
      <AliceCarousel
        {...extraProps}
        mouseTracking
        items={items}
        responsive={{
          0: { items: 1 },
          568: { items: 1 },
          1024: { items: 1 },
        }}
        controlsStrategy="alternate"
      />
    </StyledCarouselContainer>
  )
}

export default Carousel
